
import Vue from 'vue';

export default Vue.extend({
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    ratio: {
      type: String,
      required: false,
      default: 'square',
      validator(value): boolean {
        if (`${value}`.trim().toLowerCase() === 'square') {
          return true;
        }

        const [width, heigth]: Array<string> = `${value}`.trim()
          .toUpperCase()
          .split('X');

        return !Number.isNaN(+width) && !Number.isNaN(+heigth);
      },
    },
    cover: {
      type: Boolean,
      required: false,
      default: false,
    },
    fallbackImage: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    useFallback: false,
  }),
  computed: {
    currentSrc(): string {
      if (!this.src && this.fallbackImage) return this.fallbackImage;

      return this.useFallback ? this.fallbackImage : this.src;
    },
    relativeHeight(): number {
      if (this.ratio === 'square') {
        return 100;
      }

      const [width, heigth]: Array<string> = this.ratio.trim()
        .toUpperCase()
        .split('X');

      return +((+heigth / +width) * 100).toFixed(2);
    },
    style(): string {
      return `padding-bottom: ${this.relativeHeight}%`;
    },
  },
  watch: {
    src() {
      /* @ts-ignore */
      this.useFallback = false;
    },
  },
  methods: {
    setFallback() {
      /* @ts-ignore */
      this.useFallback = !!this.fallbackImage;
    },
  },
});
